import { Box, Card, Divider, Grid, Heading, T } from '@veracity/vui'
import { Fragment } from 'react'

import { ScenarioDetailed } from '@/interfaces'
import { getDurationInYears } from '@/utils'

import { ScenarioDetailsStatus } from './ScenarioDetailsStatus'

interface Props {
  scenarioInfo?: ScenarioDetailed
}
export const ScenarioDetailsContentInfoBox = ({ scenarioInfo }: Props) => {
  const calculationPeriod =
    scenarioInfo?.startYear &&
    getDurationInYears(scenarioInfo.startYear, scenarioInfo?.endYear)

  const definitions = [
    { label: 'ISO', value: scenarioInfo?.isoBaName },
    {
      label: 'System Configuration',
      value: scenarioInfo?.systemConfigurationString
    },
    {
      label: 'Calculation period',
      value: calculationPeriod && `${calculationPeriod} year(s)`
    },
    {
      label: 'Status',
      value: scenarioInfo && (
        <ScenarioDetailsStatus scenarioInfo={scenarioInfo} />
      )
    }
  ]

  return (
    <Card py={2} px={6}>
      <Grid gridTemplateColumns="1fr 1em 2fr 1em 1fr 1em 1fr" gap={2} w="100%">
        {definitions.map((item, index) => (
          <Fragment key={index}>
            <Box column alignItems="center" justify="space-between">
              <Heading color="sandstone.50" size="h6">
                {item.label}
              </Heading>
              {typeof item.value === 'string' ? (
                <T w="100%" isTruncated textAlign="center" size="lg">
                  {item.value}
                </T>
              ) : (
                item.value
              )}
            </Box>

            {index + 1 < definitions.length && <Divider isVertical />}
          </Fragment>
        ))}
      </Grid>
    </Card>
  )
}
